(function ($) {
  'use strict';

  /**
   * Behaviour for Repeater Question type
   */
  class RepeatingQuestion {
    constructor(elem) {
      this.$addRowButton = $(elem).find('.js-repeater-add-row');
      this.$rows = $(elem).find('.js-repeater-row');
      this.parentQuestionSlug = $(elem).data('question-slug');
      this.$rowContainer = $(elem).find('.js-repeater-row-container');
      this.$notApplicable = $(elem).find('.js-file-upload-not-applicable');
      this.questionType = $(elem).data('question-type');
      this.$repeatingTable = $(elem).find('.js-repeating-table');
      this.maxRows = $(this.$repeatingTable).data('max-rows');
      this.$fileUploadDeleteWarning = $(elem).find(
        '.js-user-file-delete-warning'
      );

      // Get the data required to render inputs
      this.inputs = $(elem)
        .find('.js-repeater-input-column')
        .map(function () {
          return $(this).data();
        })
        .get();

      // Add event listeners for 'Add row' and 'Delete row' buttons
      this.$addRowButton.on('click', $.proxy(this.addRow, this));
      $(elem).on(
        'click',
        '.js-repeater-delete-row',
        $.proxy(this.deleteRow, this)
      );
    }

    addRow() {
      // If we haven't yet reached the maximum number of rows
      if (this.$rows.length < this.maxRows) {
        // Create the table row
        let $newRow = $(
          `<tr class="js-repeater-row" data-row-index="${this.$rows.length}">`
        ).appendTo(this.$rowContainer);

        // Create each input in a new <td>
        this.inputs.forEach((input) => {
          $newRow.append(`
              <td>
                <label for="${this.parentQuestionSlug}.value.${this.$rows.length}.${input.slug}" class="u-visually-hidden">${input.label}</label>
                <input
                  id="${this.parentQuestionSlug}.value.${this.$rows.length}.${input.slug}"
                  name="${this.parentQuestionSlug}[value][${this.$rows.length}][${input.slug}]"
                  type="${input.type}"
                  value=""
                >
              </td>
            `);
        });

        // Add the 'Delete row' button
        $newRow.append(`
            <td>
              <button type="button" class="btn btn--delete js-repeater-delete-row">
                <span class="u-visually-hidden">Delete this row</span>
                <span class="icon-cross"></span>
              </button>
            </td>
          `);

        this.$rows = this.$rows.add($newRow);
      }

      // If we've reached the max number of rows, disable the 'Add row' button
      if (this.$rows.length >= this.maxRows) {
        this.$addRowButton.prop('disabled', true);
      }
    }

    deleteRow(e) {
      let $deleteButton = $(e.target);
      let $row = $deleteButton.closest('.js-repeater-row');

      // Remove the row from both the DOM and the $rows set
      $row.remove();
      this.$rows = this.$rows.not($row);

      // If we're below the max number of rows, enable the 'Add row' button
      if (this.$rows.length < this.maxRows) {
        this.$addRowButton.prop('disabled', false);
      }

      // record any removed documents with a hidden input
      if (this.questionType === 'File') {
        if ($row.data('id')) {
          this.$addRowButton.before(
            `<input id=${
              this.parentQuestionSlug
            }.id.remove type="hidden" name="${
              this.parentQuestionSlug
            }[id][][remove]" value="${$row.data('id')}">`
          );
        }
        if (this.$fileUploadDeleteWarning.length < 1) {
          let $deleteFileWarning = this.$repeatingTable.after(
            '<div class="js-user-file-delete-warning message message--warning">You have removed a document. Please save the page to save this change</div>'
          );
          this.$fileUploadDeleteWarning = this.$fileUploadDeleteWarning.add(
            $deleteFileWarning
          );
        }
      }
    }
  }

  this.RepeatingQuestion = RepeatingQuestion;
}.call(Framework, jQuery));
